import { FC, memo } from 'react';

import { useBooleanFieldValue } from './hooks/useBooleanFieldValue';
import { BooleanFieldValueProps } from './types/BooleanFieldValueProps';

const BooleanFieldValueComponent: FC<BooleanFieldValueProps> = ({ field }) => {
  const { label } = useBooleanFieldValue(field);
  return <>{label}</>;
};

export const BooleanFieldValue = memo(BooleanFieldValueComponent);
